import './like_component.scss'
import { json } from 'd3-fetch'
import { Controller } from 'stimulus'

export default class extends Controller {
  static classes = ['liked']
  static targets = ['icon', 'text']
  static values = {
    url: String
  }

  toggle = (): void => {
    json(this.urlValue).then(data => {
      if (data.liked === true) {
        this.iconTarget.classList.add(this.likedClass)
        this.textTarget.innerText = 'Liked'
      } else {
        this.iconTarget.classList.remove(this.likedClass)
        this.textTarget.innerText = 'Like'
      }
    }).catch(error => console.error(error))
  }

  showFloatingLabel = (event: Event): void => {
    if (this.label.length === 0) return
    this.floatingLabelController.show(this.label)
  }

  hideFloatingLabel = (event: Event): void => {
    this.floatingLabelController.hide()
  }

  updateFloatingLabel = (event: Event): void => {
    this.floatingLabelController.update(event)
  }

  get floatingLabelController (): object {
    return this.application.getControllerForElementAndIdentifier(document.getElementById('floating_label'), 'floating-label')
  }

  get label (): string {
    return this.liked ? 'Unlike' : 'Like'
  }

  get liked (): boolean {
    return this.iconTarget.classList.contains(this.likedClass)
  }
}
